import { AxiosError } from "axios";
import { middlewareApi } from "../../middlewares/middlewareApi";
import mainApi from "../../api/mainApi";
import { HistorialResponse } from "../../interfaces/historial-bl/historial.bl.interface";

const historialBlService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Get list history by BL
     */
    getHistorialBL: builder.query<
      HistorialResponse,
      {
        id_bl: number;
      }
    >({
      queryFn: async ({ id_bl }) => {
        try {
          const { data } = await mainApi.get("historial/getHistorial", {
            params: {
              id_bl,
            },
          });
          return { data };
        } catch (error) {
          const err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),
  }),
});

export const { useGetHistorialBLQuery } = historialBlService;
